export const planningQuestions: string[] = [
  'What should I teach next?',
  'How should I explain it?',
  'Which grooming skill should come first?',
  'How should I correct this student’s mistake?',
  'What should they practice before moving on?',
]

export const notBecause: string[] = ["Not because you don't know how to groom dogs."]

export const scratchHabits: string[] = [
  'You search for teaching ideas.',
  'You recreate explanations.',
  'You repeat whatever worked last time.',
  'You improvise progressions.',
  'You demonstrate the same shaping technique again.',
  'You try to remember which skill should come next.',
]

export const painPoints: string[] = [
  'Hours spent preparing grooming lessons.',
  'Repeating the same explanations because they are easiest to remember.',
  'Students progressing without a clear sequence.',
  'Complex grooming techniques explained differently every time.',
  'No consistent error-correction method.',
  'No clear student progress tracking.',
  'More time planning and less time teaching.',
  'Entering classes with an idea instead of a complete structure.',
]
